// Section labels + display helpers for country-return forms.
// Extracted from CountryReturn.jsx in the Phase-3 refactor so the
// page file stays under the 500-LOC frontend cap.

export const SECTION_LABELS = {
  // FR CA3 / DE UStVA (the generic baseline)
  outputs: "Outputs — sales, services, transfers",
  inputs: "Inputs — deductible VAT",
  totals: "Totals (computed)",
  payable: "Net payable",
  // ES Modelo 303
  iva_devengado: "IVA devengado — output VAT",
  iva_deducible: "IVA deducible — input VAT",
  resultado: "Resultado — liquidation result",
  recargo_equivalencia: "Recargo de equivalencia",
  info_adicional: "Información adicional",
  pagina4: "Página 4 — last return of the year, if exempt from modelo 390",
  // UK 9-Box (HMRC names)
  vat_due: "VAT due on sales (Boxes 1–2)",
  vat_reclaimed: "VAT reclaimed on purchases (Box 4)",
  net_vat: "Net VAT",
  net_totals: "Net totals (Boxes 6–7)",
  adjustments: "Your workings — import VAT, reverse charges, other items (feed Boxes 1, 4 and 6)",
  // IT LIPE
  period: "Periodo — period identifier",
  vat: "IVA — VAT figures",
  carryovers: "Crediti / debiti riportati",
  acconto: "Acconto",
  result: "Risultato — net result",
  // SE momsdeklaration — the form's own section letters, with what each holds.
  se_a: "A — Taxable sales, excluding VAT",
  se_b: "B — Output VAT on sales",
  se_c: "C — Purchases where you account for the VAT",
  se_d: "D — VAT you owe on those purchases",
  se_e: "E — Sales without Swedish VAT",
  se_h: "H — Imports",
  se_i: "I — VAT you owe on imports",
  se_f: "F — Input VAT",
  se_g: "G — VAT to pay or reclaim",
  // A2-234 (G7) — NL had none (the form showed "Binnenland", "Verlegging"…),
  // and DK/PT's information boxes fell back to a bare "Info".
  binnenland: "1 — Supplies in the Netherlands",
  verlegging: "2 — Domestic supplies where the VAT is shifted to you",
  buitenland: "3 — Supplies to or in other countries",
  uit_buitenland: "4 — Supplies to you from other countries",
  voorbelasting: "5 — Input VAT",
  resultaat: "Result — VAT to pay or reclaim",
  info: "Information reported with the return (no VAT of its own)",
};

// v0.4.63 — humanise an unknown section id (e.g. some future form
// adding `prepayments`) so the form is never blank.
export const humanizeSection = (sec) =>
  String(sec || "section")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const KIND_BADGE = {
  computed: "bg-teal-50 dark:bg-teal-900/40 text-teal-700 dark:text-teal-300 border-teal-200 dark:border-teal-800",
  typed_in: "bg-amber-50 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border-amber-200 dark:border-amber-800",
  // v0.4.90 — OUT OF SCOPE pill was unreadable in dark mode.
  // First attempt (slate-800 on slate-950 card) was still too low
  // contrast — operator reported "pills still blending". The pill
  // signals a blocker condition (engine refuses to file), so we
  // colour-link it to the orange OUT OF SCOPE warning text that
  // already lives in the same card. Saturated amber bg + dark
  // amber text in light mode, and amber-300 text on amber-950 bg
  // in dark mode — both pass WCAG AA against their respective
  // card backgrounds (slate-50 / slate-950).
  stub_zero: "bg-amber-100 dark:bg-amber-950/80 text-amber-800 dark:text-amber-200 border-amber-300 dark:border-amber-700",
};
